<template>
	<v-dialog v-model="showDialog" scrollable max-width="70%" min-width="500px" :fullscreen="isFullscreen">
		<v-card style="padding-bottom: 25px" class="justify-center text-center card-rounded" :loading="loading">
			<v-card-title
				class="pa-0 white--text justify-center text-center"
				style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
			>
				<v-toolbar
					class="justify-center text-center white--text card-rounded"
					flat
					dense
					style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
					color="secondary"
				>
					<v-btn depressed color="secondary" @click="onBackClick"> <v-icon>mdi-chevron-left</v-icon>Back</v-btn>
					<v-spacer></v-spacer>
					<v-toolbar-title class="headline white--text text-center justify-center">Quick Book</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon color="white" @click="BackToDashboard">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
			</v-card-title>

			<v-card-text>
				<v-container class="justify-center text-center">
					<v-row class="justify-center text-center">
						<v-col cols="12" md="8" :lg="6" class="justify-center text-center ma-0">
							<view-locum-details-card v-if="locum && locum.id" :locum-preview-id="locum.id" source="locumDirectory"></view-locum-details-card>
						</v-col>

						<v-col cols="12" :lg="6" class="justify-center text-center pa-2">
							<v-form ref="form" v-model="form">
								<v-row>
									<v-col class="justify-center text-center">
										<v-btn-toggle v-model="calendarInputMode" mandatory>
											<v-btn
												rounded
												small
												:color="calendarInputMode == 0 ? 'primary' : '#FFF'"
												:class="[calendarInputMode == 0 ? 'white--text' : 'primary--text text--darken-2']"
												style="
													border-radius: 20px 0px 0px 20px;
													font-family: Montserrat;
													font-style: normal;
													font-weight: bold;
													font-size: 14px;
													line-height: 17px;
													text-align: center;
												"
												@click="calculateRequestDates(0)"
											>
												Date range
											</v-btn>

											<v-btn
												rounded
												small
												:color="calendarInputMode == 1 ? 'primary' : '#FFF'"
												:class="[calendarInputMode == 1 ? 'white--text' : 'primary--text text--darken-2']"
												style="
													border-radius: 0px 20px 20px 0px;
													font-family: Montserrat;
													font-style: normal;
													font-weight: bold;
													font-size: 14px;
													line-height: 17px;
													text-align: center;
												"
												@click="calculateRequestDates(1)"
											>
												Specific days
											</v-btn>
										</v-btn-toggle>
									</v-col>
								</v-row>
								<v-row class="justify-center text-center">
									<v-col :cols="12" :sm="8" :md="6" :xs="12" class="justify-center text-center">
										<v-date-picker
											v-model="selectedDates"
											width="300"
											:min="new Date().toISOString().substr(0, 10)"
											header-color="primary"
											color="primary"
											full-width
											no-title
											:multiple="calendarInputMode == 1"
											:range="calendarInputMode == 0"
											class="elevation-0"
										></v-date-picker>
									</v-col>
								</v-row>

								<v-row>
									<v-col>
										<v-dialog
											ref="startDatedialog"
											v-model="startDateModal"
											:value="computedstartDateFormattedMomentjs"
											clearable
											:return-value.sync="startDate"
											persistent
											width="290px"
										>
											<template #activator="{ on }">
												<span class="font-weight-bold">Start Date:</span>
												<v-text-field v-model="startDate" :rules="[rules.startDate]" filled dense readonly v-on="on"></v-text-field>
											</template>
											<v-date-picker v-model="startDate" :allowed-dates="allowedStartDates" header-color="primary" color="primary" :min="minDate" scrollable>
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="startDateModal = false">Cancel</v-btn>
												<v-btn
													text
													color="primary"
													@click="
														$refs.startDatedialog.save(startDate);
														if (calendarInputMode === 0) calculateRequestDates();
													"
													>OK</v-btn
												>
											</v-date-picker>
										</v-dialog>
									</v-col>

									<v-col>
										<v-dialog ref="endDateDialog" v-model="endDateModal" :return-value.sync="endDate" persistent width="290px">
											<template #activator="{ on }">
												<span class="font-weight-bold">End Date:</span>
												<v-text-field
													v-model="endDate"
													:value="computedendDateFormattedMomentjs"
													clearable
													:rules="[rules.endDate]"
													filled
													dense
													readonly
													v-on="on"
												></v-text-field>
											</template>
											<v-date-picker v-model="endDate" header-color="primary" color="primary" :min="minDate" scrollable>
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="endDateModal = false">Cancel</v-btn>
												<v-btn
													text
													color="primary"
													@click="
														$refs.endDateDialog.save(endDate);
														if (calendarInputMode === 0) calculateRequestDates();
													"
													>OK</v-btn
												>
											</v-date-picker>
										</v-dialog>
									</v-col>
								</v-row>

								<p class="font-weight-bold black--text mb-0 mt-0">Time (Times can be edited below)</p>
								<v-row>
									<v-col>
										<v-dialog ref="startTimeDialog" v-model="startTimeModal" :return-value.sync="startTime" persistent width="290px">
											<template #activator="{ on }">
												<span class="font-weight-bold">Start Time:</span>
												<v-text-field v-model="startTime" placeholder="Start Time:" readonly filled dense v-on="on"></v-text-field>
											</template>
											<v-time-picker v-if="startTimeModal" v-model="startTime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="startTimeModal = false">Cancel</v-btn>
												<v-btn
													text
													color="primary"
													@click="
														$refs.startTimeDialog.save(startTime);
														updateRequestDateTimes(startTime, '');
													"
													>OK</v-btn
												>
											</v-time-picker>
										</v-dialog>
									</v-col>

									<v-col>
										<v-dialog ref="endTimeDialog" v-model="endTimeModal" :return-value.sync="endTime" persistent width="290px">
											<template #activator="{ on }">
												<span class="font-weight-bold">End Time:</span>
												<v-text-field v-model="endTime" placeholder="End Time:" readonly filled dense v-on="on"></v-text-field>
											</template>
											<v-time-picker v-if="endTimeModal" v-model="endTime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="endTimeModal = false">Cancel</v-btn>
												<v-btn
													text
													color="primary"
													@click="
														$refs.endTimeDialog.save(endTime);
														updateRequestDateTimes('', endTime);
													"
													>OK</v-btn
												>
											</v-time-picker>
										</v-dialog>
									</v-col>
								</v-row>

								<p v-if="startDate !== null && endDate !== null && endDate !== ''" class="font-weight-bold black--text mb-0 mt-0">Change times per day</p>
								<v-row v-if="startDate !== null && endDate !== null && endDate !== ''">
									<v-col>
										<div style="display: flex; overflow: auto">
											<v-card
												v-for="date in request_dates"
												:key="date.date"
												outlined
												elevation="1"
												class="ml-1 mr-1 mt-2 mb-2 pl-1 pr-1"
												style="border-radius: 8px; !important"
												@click="onClickDateIcon(date)"
											>
												<v-row no-gutters>
													<v-col cols="12">
														<calendar-date-icon
															:color="'primary'"
															:date="date.date"
															:start_time="getLocumDayTime(date.date, 'start_time')"
															:end_time="getLocumDayTime(date.date, 'end_time')"
															small
															class="ml-1 mr-1 mt-2 mb-0 justify-center text-center"
															@click="onClickDateIcon(date)"
														>
														</calendar-date-icon>
													</v-col>
												</v-row>
											</v-card>
										</div>
									</v-col>
									<v-col>
										<v-dialog v-model="showEditRequestTimeDialog" persistent scrollable width="290px" :max-width="$vuetify.breakpoint.mobile ? '80%' : '25%'">
											<v-card class="justify-center text-center card-rounded pb-5" min-height="40vh">
												<v-card-title
													class="pa-2 white--text justify-center text-center primary"
													style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
												>
													<v-row>
														<v-spacer></v-spacer>
														<span class="headline white--text">{{ EditRequestTimeDialogTitle }}</span>
														<v-spacer></v-spacer>
													</v-row>
													<v-btn icon color="white" @click="closeRequestTimeDialog()">
														<v-icon>mdi-close</v-icon>
													</v-btn>
												</v-card-title>

												<v-card-text class="text-center justify-center">
													<v-container class="card-rounded pb-2 text-center justify-center">
														<v-form>
															<div>
																<v-row>
																	<v-col>
																		<v-dialog v-model="startTimeModal" :return-value.sync="startTime" persistent width="290px">
																			<template #activator="{ on }">
																				<span class="font-weight-bold">Start Time:</span>
																				<v-text-field
																					v-model="startTimeEdit"
																					placeholder="Start Time:"
																					readonly
																					filled
																					dense
																					v-on="on"
																				></v-text-field>
																			</template>
																			<v-time-picker
																				v-if="startTimeModal"
																				v-model="startTimeChange"
																				full-width
																				format="24hr"
																				:allowed-minutes="[0, 15, 30, 45]"
																			>
																				<v-spacer></v-spacer>
																				<v-btn text color="primary" @click="startTimeModal = false">Cancel</v-btn>
																				<v-btn text color="primary" @click="updateStartTimeEdit()">OK</v-btn>
																			</v-time-picker>
																		</v-dialog>
																	</v-col>
																</v-row>
																<v-row>
																	<v-col>
																		<v-dialog v-model="endTimeModal" :return-value.sync="endTime" persistent width="290px">
																			<template #activator="{ on }">
																				<span class="font-weight-bold">End Time:</span>
																				<v-text-field
																					v-model="endTimeEdit"
																					placeholder="End Time:"
																					readonly
																					filled
																					dense
																					v-on="on"
																				></v-text-field>
																			</template>
																			<v-time-picker
																				v-if="endTimeModal"
																				v-model="endTimeChange"
																				full-width
																				format="24hr"
																				:allowed-minutes="[0, 15, 30, 45]"
																			>
																				<v-spacer></v-spacer>
																				<v-btn text color="primary" @click="endTimeModal = false">Cancel</v-btn>
																				<v-btn text color="primary" @click="updateEndTimeEdit()">OK</v-btn>
																			</v-time-picker>
																		</v-dialog>
																	</v-col>
																</v-row>
															</div>
														</v-form>
													</v-container>
												</v-card-text>
												<v-card-actions>
													<v-row class="pb-1">
														<v-spacer />
														<v-col>
															<v-btn block class="white--text mt-1" :height="30" color="primary" @click="saveTimesForDate()"
																><span style="font-size: 10px">Save</span></v-btn
															>
														</v-col>
													</v-row>
												</v-card-actions>
											</v-card>
										</v-dialog>
									</v-col>
								</v-row>

								<div v-if="showLunchOptions">
									<p class="font-weight-bold black--text mb-0 mt-0">Lunch</p>
									<v-row mt-0>
										<v-col class="text-center justify-center">
											<v-spacer />
											<v-btn-toggle v-model="lunchValue" block dense rounded color="secondary" class="white--text" mandatory>
												<v-btn value="paid"> Paid </v-btn>
												<v-btn style="display: none" value="default"></v-btn>
												<v-btn value="unpaid" :disabled="lunchDuration === '0.5'"> Unpaid </v-btn>
											</v-btn-toggle>
											<v-spacer />
										</v-col>
									</v-row>

									<v-row v-if="lunchValue !== 'default'" no-gutters class="mt-3 mb-2">
										<v-col class="text-center justify-center">
											<v-spacer />
											<v-btn-toggle v-model="lunchDuration" mandatory depressed block rounded dense color="secondary" class="white--text">
												<v-btn value="0.5" :disabled="lunchValue === 'unpaid'"> 30 min </v-btn>
												<v-btn value="1"> 1 hour </v-btn>
											</v-btn-toggle>
											<v-spacer />
										</v-col>
									</v-row>
								</div>
							</v-form>

							<v-row class="justify-center text-center pt-5">
								<v-col cols="6">
									<v-btn class="button-rounded continue-signup-button" style="text-transform: none !important" color="primary" @click="onBackClick"
										>Back<v-icon>close</v-icon></v-btn
									>
								</v-col>
								<v-col cols="6">
									<v-btn
										:disabled="startDate == null || endDate == null || (lunchValue === 'default' && showLunchOptions)"
										class="button-rounded continue-signup-button"
										style="text-transform: none !important"
										color="primary"
										@click="quickBookLocum"
										>Continue<v-icon>arrow_forward</v-icon></v-btn
									>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import { bus } from '@/main';
import store from '@/store';
import moment from 'moment';

import ViewLocumDetailsCard from '../../../custom/ViewLocumDetailsCard.vue';
import CalendarDateIcon from '@/components/custom/CalendarDateIcon.vue';
import { getDefaultShiftTimes } from '@/utils/util';

export default {
	name: 'PracticeQuickBookFeaturedLocumDialog',
	components: {
		ViewLocumDetailsCard,
		CalendarDateIcon,
	},
	props: {},
	data: () => ({
		windowWidth: window.innerWidth,
		loading: false,
		calendarInputMode: 0,
		startDateModal: false,
		endDateModal: false,
		form: false,

		startTime: '09:00',
		endTime: '17:00',

		startDate: null,
		endDate: null,
		minDate: new Date().toISOString().substr(0, 10),

		startTimeModal: false,
		endTimeModal: false,
		range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
		selectedDatesSorted: [],
		lunchDuration: null,
		lunchValue: 'default',
		showEditRequestTimeDialog: false,
		EditRequestTimeDialogTitle: '',
		startTimeEdit: '',
		endTimeEdit: '',
		startTimeChange: '', //variable for dialog to keep separate to not update time incase of cancel
		endTimeChange: '', //variable for dialog to keep separate to not update time incase of cancel
		request_dates: [],

		apiRequest: false,

		rules: {
			startDate: v => !!v || 'Start date required',
			endDate: v => !!v || 'End date required',
			budgetfrom: v => !!v || 'Required',
			budgetto: v => !!v || 'Required',
		},

		showDialog: false,
		locum: undefined,
		locumIndex: undefined,
	}),
	computed: {
		isFullscreen() {
			return this.windowWidth < 700;
		},
		yearsExperience() {
			return moment().diff(this.locum.experience.start_date, 'years');
		},
		rateArray() {
			let arr = [0, 0];

			Object.values(this.locum.working_hours).forEach(dayType => {
				if (arr[0] == 0 || dayType.rate < arr[0]) {
					arr[0] = dayType.rate;
				}
				if (arr[1] == 0 || dayType.rate > arr[1]) {
					arr[1] = dayType.rate;
				}
			});
			return arr;
		},
		selectedDates: {
			get: function () {
				return this.selectedDatesSorted;
			},
			set: function (newValue) {
				this.selectedDatesSorted = newValue.sort((a, b) => moment(a).diff(b, 'days'));
			},
		},
		lunchPeriod() {
			if (!this.hasLunchBreak) {
				return 0;
			}
			return this.lunchDuration === '1' ? 1 : 0.5;
		},
		hasLunchBreak() {
			return this.showLunchOptions && this.lunchValue !== 'default';
		},
		hasPaidLunch() {
			return this.hasLunchBreak && this.lunchValue === 'paid';
		},
		lengthOfDay() {
			return this.formatTime(this.endTime).diff(this.formatTime(this.startTime), 'hours');
		},
		showLunchOptions() {
			return this.lengthOfDay > 5;
		},
		computedstartDateFormattedMomentjs() {
			return this.startDate ? moment(this.startDate).format('dddd, MMMM Do YYYY') : '';
		},
		computedendDateFormattedMomentjs() {
			return this.endDate ? moment(this.endDate).format('dddd, MMMM Do YYYY') : '';
		},
		company() {
			return store.getters.company;
		},
		manager() {
			return store.getters.user;
		},
	},
	watch: {
		selectedDatesSorted() {
			this.startDate = this.selectedDatesSorted[0];
			this.endDate = this.selectedDatesSorted[this.selectedDatesSorted.length - 1];
			this.calculateRequestDates();
		},
	},
	created() {
		const { start, end } = getDefaultShiftTimes(this.tenant);
		this.startTime = start;
		this.endTime = end;
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	async mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});

		bus.$on('dismiss-quickbook-popup', () => {
			this.showDialog = false;
		});
		bus.$on('show-quickbook-popup', payload => {
			let locum = payload.locum;
			let index = payload.index;

			this.locum = locum;
			this.locumIndex = index;

			this.showDialog = true;
		});
	},
	methods: {
		...mapActions('availability', ['LoadAvailabilityByProfessionalForCompany']),

		...mapActions('bookings', ['LoadProfessionalBookings']),

		...mapMutations('offers', ['SET_PRACTICE_OFFER']),

		onResize() {
			this.windowWidth = window.innerWidth;
		},

		getDates(date, end_date) {
			let dates = [];
			let count = moment(end_date).diff(date, 'days');
			for (let iteration = 0; iteration <= count; iteration++) {
				let futureDate = moment(date).add(iteration, 'days').format('YYYY-MM-DD');
				dates.push(futureDate);
			}
			return dates.sort((a, b) => moment(a).diff(moment(b)));
		},

		async quickBookLocum() {
			this.loading = true;
			let locum = this.locum;

			const dates = this.getDates(this.startDate, this.endDate);

			await store.dispatch('PERFORM_LOCUM_SEARCH_SPECIFIC', {
				profession: locum.profession,
				startDate: this.startDate,
				endDate: this.endDate,
				id: locum.id,
			});

			const { id: companyId, name, contact, email, profile: industry, address } = this.company;

			const body = {
				start_time: this.startTime,
				end_time: this.endTime,
				date: this.startDate,
				end_date: this.endDate,
				company: {
					id: companyId,
					name,
					contact,
					email,
					industry,
					address,
				},
				rates: [this.rateArray[0], this.rateArray[1]],
				notes: 'no notes',
				profession: locum.profession,
				experience: this.yearsExperience,
				languages: locum.languages,
				lunch: {
					allowed: this.hasLunchBreak,
					period: this.lunchPeriod,
					paid: this.hasPaidLunch,
				},
				available_dates: dates,
				request_dates: this.request_dates,
			};

			locum.available_dates = await this.getAvailableDates(this.locum);
			locum.request_dates = body.request_dates; // Adding request_dates to Locum object
			locum.previousContext = 'practice-dashboard-landing-zone';
			this.SET_PRACTICE_OFFER(body);
			//store.dispatch('setPracticeOffer', body);
			store.dispatch('setPracticeLocumAvailabilitySlotSelected', locum);
			store.dispatch('setPracticeViewingLocum', [locum]);
			bus.$emit('change-context', 'practice-to-locum-create-booking-request');

			this.showDialog = false;
			this.loading = false;
			this.BackToDashboard();
		},
		formatTime(val) {
			return moment(moment().format('YYYY-MM-DD ') + val);
		},
		allowedEndDates(val) {
			return this.startDate ? moment(val).isSameOrAfter(moment(this.startDate)) : true;
		},

		allowedStartDates(val) {
			return this.endDate ? moment(val).isSameOrBefore(moment(this.endDate)) : true;
		},

		allowedDatesAll(val) {
			return this.allowedEndDates(val) && this.allowedStartDates(val);
		},

		async getAvailableDates(locum) {
			const date = this.startDate;
			const end_date = this.endDate;
			const search_dates = this.getDates(this.startDate, this.endDate);
			const avails = await this.LoadAvailabilityByProfessionalForCompany({
				companyId: store.getters.company.id,
				professionalId: locum.id,
				start_date: date,
				end_date,
			});

			const bookings = await this.LoadProfessionalBookings({
				accountId: locum.id,
				startDate: date,
				endDate: end_date,
			});

			const allEvents = avails.concat(bookings);

			const datesArray = search_dates.reduce((datesArr, date) => {
				datesArr.push({ date, already_booked: false, status: 'Possibly Available' });
				return datesArr;
			}, []);

			const mappedDates = datesArray.map(availDate => {
				const matchingEvents = allEvents.filter(({ available_dates, booking_dates }) => {
					const datesArr = available_dates ? available_dates : booking_dates;
					if (!datesArr) {
						return false;
					}
					return datesArr.includes(availDate.date);
				});

				if (matchingEvents.length === 0) {
					return availDate;
				}

				let dateStatus = 'Possibly Available';
				let availability = { start_time: '', end_time: '' };
				let isBooked = false;

				for (const { status, start_time, end_time } of matchingEvents) {
					const { status: existingStatus } = availDate;

					if (status === 'confirmed') {
						dateStatus = 'Unavailable';
						isBooked = true;
					}
					if (status === 'unavailable' && existingStatus !== 'Unavailable') {
						dateStatus = 'Unavailable';
					}
					if ((status === 'open' || status === 'requested') && existingStatus !== 'Unavailable') {
						dateStatus = 'Available';
						availability = {
							start_time,
							end_time,
						};
					}
					if (status === 'partially-confirmed' && existingStatus !== 'Unavailable') {
						dateStatus = 'Unavailable';
					}
				}

				availDate.status = dateStatus;
				availDate.already_booked = isBooked;
				if (availability.start_time && availability.end_time) {
					availability.id = locum.id;
					availability.date = date;
					availDate.availability = availability;
				}

				return availDate;
			});

			return mappedDates;
		},
		onBackClick() {
			bus.$emit('show-featured-popup');
			bus.$emit('dismiss-quickbook-popup');
		},

		BackToDashboard() {
			bus.$emit('dismiss-quickbook-popup');
		},

		calculateRequestDates(inputmode = null) {
			if (this.startDate === null && this.endDate === null) return;
			if (inputmode !== null) {
				switch (inputmode) {
					case 0:
						this.calendarInputMode = 0;
						break;
					case 1:
						this.calendarInputMode = 1;
						break;

					default:
						break;
				}
			}
			this.request_dates = [];
			if (this.calendarInputMode == 1) {
				for (let index = 0; index < this.selectedDatesSorted.length; index++) {
					let date = moment(this.selectedDatesSorted[index]).format('YYYY-MM-DD');
					this.request_dates.push({
						date: date,
						end_time: moment(`${date} ${this.endTime}`).format(),
						start_time: moment(`${date} ${this.startTime}`).format(),
					});
				}
			} else {
				let startDay = this.startDate; //this.selectedDatesSorted[0];
				let endDay = this.endDate; //this.selectedDatesSorted[this.selectedDatesSorted.length - 1];
				const countDays = startDay === endDay ? 0 : moment(endDay).startOf('day').diff(moment(startDay).endOf('day'), 'days') + 1;

				for (let day_index = 0; day_index <= countDays; day_index++) {
					let day = moment(startDay).add(day_index, 'days').format('YYYY-MM-DD');
					this.request_dates.push({
						date: day,
						end_time: moment(`${day} ${this.endTime}`).format(),
						start_time: moment(`${day} ${this.startTime}`).format(),
					});
				}
			}
			return this.request_dates;
		},

		getLocumDayTime(day, time) {
			if (this.request_dates) {
				const request_date = this.request_dates.find(({ date }) => date === day)[time];
				return moment(request_date).format('HH:mm');
			}

			return '';
		},

		onClickDateIcon(date) {
			this.EditRequestTimeDialogTitle = date.date;
			this.startTimeEdit = moment(date.start_time).format('HH:mm');
			this.endTimeEdit = moment(date.end_time).format('HH:mm');
			this.startTimeChange = this.startTimeEdit;
			this.endTimeChange = this.endTimeEdit;
			this.showEditRequestTimeDialog = true;
		},

		closeRequestTimeDialog() {
			this.showEditRequestTimeDialog = false;
		},

		updateStartTimeEdit() {
			this.startTimeEdit = this.startTimeChange;
			this.startTimeModal = false;
		},

		updateEndTimeEdit() {
			this.endTimeEdit = this.endTimeChange;
			this.endTimeModal = false;
		},

		saveTimesForDate() {
			let newDateTime = {
				date: this.EditRequestTimeDialogTitle,
				end_time: moment(`${this.EditRequestTimeDialogTitle} ${this.endTimeEdit}`).format(),
				start_time: moment(`${this.EditRequestTimeDialogTitle} ${this.startTimeEdit}`).format(),
			};
			var index = this.request_dates.findIndex(date => date.date == this.EditRequestTimeDialogTitle);
			this.request_dates[index] = newDateTime;
			this.showEditRequestTimeDialog = false;
		},

		updateRequestDateTimes(startTime, endTime) {
			if (startTime !== '') {
				for (let index = 0; index < this.request_dates.length; index++) {
					this.request_dates[index].start_time = moment(`${this.request_dates[index].date} ${startTime}`).format();
				}
			} else if (endTime !== '') {
				for (let index = 0; index < this.request_dates.length; index++) {
					this.request_dates[index].end_time = moment(`${this.request_dates[index].date} ${endTime}`).format();
				}
			}
		},
	},
};
</script>
